module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("41rcu"))).then(() => parcelRequire('d0iPb'));